// The Bible mark, ported from the designer's prototype (`ph-book` + `.ob-bible-icon`).
// Phosphor has no Bible glyph, so the prototype overlays a cross on the Book icon with
// a CSS pseudo-element. Here the two are one drawing instead: a single <svg> behaves
// like every other icon in the app — the nav's `[&_svg]` sizing rules reach it, and it
// needs no wrapper element to position the overlay against.
//
// Phosphor's own viewBox and Regular path are kept verbatim, so the mark sits on the
// same 256 grid as the glyphs beside it. The cross uses Phosphor Regular's stroke —
// 16 of 256, the 6.25% the prototype pins as `--ob-phosphor-regular-stroke` — and the
// prototype's placement: a 76.8 x 117.76 box centred at 43% of the icon's height, with
// the crossbar 36% of the way down it.

interface HeaderBibleIconProps {
	className?: string;
	/** Kept alongside `fill` because the older call sites colour icons by stroke. */
	stroke?: string;
	fill?: string;
}

const HeaderBibleIcon = ({ className, stroke, fill }: HeaderBibleIconProps) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 256 256"
		// 1em to match Phosphor's default, so one CSS rule sizes the whole nav row.
		width="1em"
		height="1em"
		fill={fill ?? stroke ?? "currentColor"}
		className={className}
	>
		<path d="M208,24H72A32,32,0,0,0,40,56V224a8,8,0,0,0,8,8H192a8,8,0,0,0,0-16H56a16,16,0,0,1,16-16H208a8,8,0,0,0,8-8V32A8,8,0,0,0,208,24Zm-8,160H72a31.82,31.82,0,0,0-16,4.29V56A16,16,0,0,1,72,40H200Z" />
		<rect x="120" y="51.2" width="16" height="117.76" />
		<rect x="89.6" y="87.83" width="76.8" height="16" />
	</svg>
);

export default HeaderBibleIcon;
